import { PageLink, PageTitle } from "_metronic/layout/core";
import UserTable from "./components/UserTable";
import { Permission } from "services/userSession/UserPermittedComponent";
import { Permissions } from "cpl-react-common/components/Enums/Permissions";
import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import { reactPlugin } from "setup/appInsights/ApplicationInsightsService";
import { withAITracking } from "@microsoft/applicationinsights-react-js";

const usersBreadCrumbs: Array<PageLink> = [
  {
    title: "Users",
    path: "/Admin/Users",
    isSeparator: false,
    isActive: true,
  },
];

const UserTablePage = () => {
  return (
    <Permission permissionPredicate={(permission) => permission === Permissions.ViewUsers}>
      <CPLAnalytics pageName="Users Table">
        <PageTitle breadcrumbs={usersBreadCrumbs}></PageTitle>
        <UserTable />
      </CPLAnalytics>
    </Permission>
  );
};

export default withAITracking(reactPlugin, UserTablePage, "Users Table");
